import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
const MyPincode = ({
    field: { name, value },
    form: { touched, errors, setFieldValue },
    ...props
}) => {
    const [contents, setcontents] = useState([])
    useEffect(() => {
        getPincodes()
    }, [])
    const getPincodes = ()=>{
        ReadAxios({completeURL:`${process.env.REACT_APP_MASTER_API}/pincode/`}).then((res)=>{
          let dataArray = res.data.resultSet.length > 0 ? res.data.resultSet : []
          dataArray = dataArray.map((item, index) => {
            return {
              key: item.pincodeMasterId,
              text: item.pincode,
              value: item.pincodeMasterId,
              raw: { ...item, index },
            };
          });
          setcontents(dataArray)
        })
      }

    
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    const handlClick = ()=>{
        if(props.reload && props.UpdatePincodeData){
            getPincodes()
            props.UpdatePincodeData()
        }
    }
    return (
        <Dropdown
            selection
            search
            style={{ width: '100%' }}
            onClick={handlClick}
            onChange={handleChange}
            options={contents}
            {...props}
        />

    )
}

export default MyPincode 